import { render, staticRenderFns } from "./NewsAll.vue?vue&type=template&id=d0fd1916&scoped=true&"
import script from "./NewsAll.vue?vue&type=script&lang=js&"
export * from "./NewsAll.vue?vue&type=script&lang=js&"
import style0 from "./NewsAll.vue?vue&type=style&index=0&id=d0fd1916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fd1916",
  null
  
)

export default component.exports